// src/api/axios.ts
import axios from 'axios';

let base = process.env.REACT_APP_API_URL;
if (!base) {
  throw new Error('REACT_APP_API_URL is not defined');
}
// Ensure it ends with a single slash
if (!base.endsWith('/')) {
  base = base + '/';
}
if (!base.endsWith('/api/')) {
  // If someone pointed at the root, append "api/"
  base = base.replace(/\/+$/, '') + '/api/';
}

console.log('🔧 Using API base URL:', base);

const api = axios.create({
  baseURL: base,                     
  headers: { 'Content-Type': 'application/json' },
});

export default api;
